export enum TicketImpact {
	Unknown,
	OneIndividual,
	OneDepartment,
	MultipleDepartment,
	EntireOrganisation,
}
